<template>
  <div class="home">
    <Header></Header>
    <Section>
      <h1 class="text-center">Wybierz interesujący Cię produkt:</h1>
      <Row mode="wrap">
        <BrandTile v-for="brand in getBrands" :key="brand.is" :brand="brand"></BrandTile>
      </Row>
    </Section>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import BrandTile from '../components/BrandTile.vue'
import Row from '../components/Row.vue'
import Section from '../components/Section.vue'

import {mapGetters} from 'vuex'

export default {
  name: 'home',
  components:{
    BrandTile,
    Row,
    Section,
    Header
  },
  computed:{
    ...mapGetters(['getBrands'])
  }
}
</script>
<style lang="scss">
  .home{
    @media(min-width: 780px){
      min-height: 100vh;
    }
  }
</style>
